import React, {Component} from "react"
import PropTypes from "prop-types"

export default class Star extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  state = {
    selectedValue: 0
  }

  _handleChange(e) {
    const {question, onChange} = this.props
    const value = parseInt(e.currentTarget.value, 10)

    this.setState(
      prevState => {
        return {
          ...prevState,
          selectedValue: value
        }
      },
      () => {
        // uuids must be prefixed with "question_"
        onChange({[`question_${question.id}`]: value})
      }
    )
  }

  componentDidUpdate(prevProps) {
    // reset state if question changes but it's the same question type
    if (prevProps.question.id !== this.props.question.id) {
      this.setState(prevState => {
        return {
          ...prevState,
          selectedValue: 0
        }
      })
    }
  }

  render() {
    const {question} = this.props
    const {selectedValue} = this.state
    const possibleValues = [1, 2, 3, 4, 5]

    return (
      <div className="star-rating" key={`answer-${question.id}`}>
        <div className={`stars ${selectedValue !== 0 ? "selected" : ""}`}>
          {possibleValues.map(value => {
            return (
              <span
                key={`answer-${question.id}-${value}`}
                className={selectedValue === value ? "selected" : null}
              >
                <input
                  type="radio"
                  name="answer"
                  id={`answer-${question.id}-${value}`}
                  value={value}
                  onChange={e => this._handleChange(e)}
                />
                <label htmlFor={`answer-${question.id}-${value}`}>
                  <i className="icon icon-feedback-star-outline" />
                  <span className="label">{value}</span>
                </label>
              </span>
            )
          })}
        </div>
        <div className="labels">
          <span className="label-1">
            {this.props.question.star.label_star_1}
          </span>
          <span className="label-5">
            {this.props.question.star.label_star_5}
          </span>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Feedback/Star/index.js